"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
import { FontSize600, ColorTextDefault, FontSize200 } from "@nxt-costco-com/forge-design-tokens";
import { ChevronRight } from "@nxt-costco-com/forge-icons/icons/ChevronRight";
import { Analytics } from "../../Analytics/index.js";
import { AdTitleWrapper, TitleTextLinkGridWrapper, TitleGrid, TitleText, LinkWrapperGrid, TitleLink, TitleLinkDefaultStyles } from "./styles.js";
const AdSetTitle = ({
  title,
  href,
  isAdSetCostco = false,
  linkLabel,
  titleVariant,
  titleAlignment,
  titleBackgroundColor,
  titleId,
  titleGridSx = {},
  titleLinkSx,
  titleSx,
  titleWrapperSx = {},
  target
}) => {
  if (!title) return null;
  return /* @__PURE__ */ jsx(
    AdTitleWrapper,
    {
      isAdSetCostco,
      sx: titleWrapperSx,
      titleBackgroundColor,
      children: /* @__PURE__ */ jsxs(TitleTextLinkGridWrapper, { container: true, hasMargin: false, children: [
        /* @__PURE__ */ jsx(TitleGrid, { sx: titleGridSx, titleAlignment, xs: true, children: /* @__PURE__ */ jsx(
          TitleText,
          {
            variant: titleVariant,
            sx: titleSx || { fontSize: FontSize600 },
            color: "default",
            component: "h2",
            id: titleId,
            children: title
          }
        ) }),
        title && href && linkLabel && /* @__PURE__ */ jsx(LinkWrapperGrid, { padding: 0, xs: 4, children: /* @__PURE__ */ jsx(
          Analytics,
          {
            analyticData: { adItem: { title: linkLabel } },
            children: /* @__PURE__ */ jsxs(
              TitleLink,
              {
                sx: titleLinkSx || TitleLinkDefaultStyles(),
                "aria-label": `${linkLabel} ${title}`,
                color: ColorTextDefault,
                href,
                variant: "t6",
                target,
                children: [
                  /* @__PURE__ */ jsx(Text, { variant: "inherit", children: linkLabel }),
                  /* @__PURE__ */ jsx(
                    ChevronRight,
                    {
                      color: "inherit",
                      height: FontSize200,
                      width: FontSize200
                    }
                  )
                ]
              }
            )
          }
        ) })
      ] })
    }
  );
};
export {
  AdSetTitle
};
